export default "__VITE_ASSET__D2iHHzR8__"